import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Snackbar, AlertColor, Slide, SlideProps } from '@mui/material';
import { Environment } from '../../environment';

interface IAlertSnackBarProps {
    /**
     * Tempo em milissegundos que ficará na tela, padrão 2 segundos(2000 milissegundos)
     */
    duracao?: number;
    /**
     * Define a cor e o ícone a ser utilizado (por padrão success)
     * error | info | success | warning
     */
    gravidade?: AlertColor;
    /**
     * Título, se não for informado terá os textos padrões e caso queira não apareça nenhum título atribua uma string vazia
     */
    titulo?: string;
    /**
     * Mensagem que aparecerá no alert
     */
    mensagem: string;
    returnedDuration?: (duration: number) => void,
}

// transição do alert
type TransitionProps = Omit<SlideProps, 'direction'>;

function TransitionLeft(props: TransitionProps) {
    return <Slide {...props} direction="left" />;
}


export const AlertSnackBar: React.FC<IAlertSnackBarProps> = ({
    duracao = Environment.DURACAO_ALERT,
    gravidade = "success",
    titulo,
    mensagem,
    returnedDuration
}) => {
    useEffect(() => {
        returnedDuration?.(duracao);
    }, [])

    const [openSnack, setOpenSnack] = useState(true);
    const handleCloseSnack = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnack(false);
    };

    if (titulo === undefined) {
        if (gravidade === 'success') titulo = "Sucesso";
        if (gravidade === 'error') titulo = "Erro";
        if (gravidade === 'warning') titulo = "Aviso";
        if (gravidade === 'info') titulo = "Informação";
    }

    return (
        <Snackbar open={openSnack} autoHideDuration={duracao} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} onClose={handleCloseSnack} TransitionComponent={TransitionLeft}>
            <Alert onClose={handleCloseSnack} severity={gravidade} sx={{ width: '100%' }} variant="filled">
                {titulo !== "" && (
                    <AlertTitle> {titulo} </AlertTitle>
                )}
                {mensagem}
            </Alert>
        </Snackbar>
    )
}
